// Define a type for the value which could be string, number, or any other types expected.
type Value = any | null | undefined;

export default class MyCustomValidation {
    private _value: Value;
    public isError: boolean;
    public errors: string[];

    constructor(value: Value) {
        this._value = value;
        this.isError = false;
        this.errors = [];
    }



    validateRequired(message: string): MyCustomValidation {
        if (this._value === null || this._value === undefined || this._value === '') {
            this.isError = true;
            this.errors.push(message);
        }
        return this;
    }

    validateNumeric(message: string): MyCustomValidation {
        // Allow numeric values including negative numbers and decimals
        if (
            this._value === null ||
            this._value === undefined ||
            !/^[-+]?\d*\.?\d+$/.test(this._value.toString())
        ) {
            this.isError = true;
            this.errors.push(message);
        }
        return this;
    }

    validateLength(min: number, max: number, message: string): MyCustomValidation {
        // Ensure _value is a string before checking its length
        if (typeof this._value !== 'string' || this._value.length < min || this._value.length > max) {
            this.isError = true;
            this.errors.push(message);
        }
        return this;
    }

    validateStringRange(min: string, max: string, message: string): MyCustomValidation {
        // Ensure _value is a string before checking its length
        if (typeof this._value !== 'string' || this._value < min || this._value > max) {
            this.isError = true;
            this.errors.push(message);
        }
        return this;
    }

    validateNumberRange(min: number, max: number, message: string): MyCustomValidation {
        // Ensure _value is a string before checking its length
        if (isNaN(this._value) || this._value < min || this._value > max) {
            this.isError = true;
            this.errors.push(message);
        }
        return this;
    }

    validateCompareDate(start: Date | null | undefined, end: Date | null | undefined, message: string): MyCustomValidation {
        // Ensure _value is a string before checking its length
        if (start && end) {
            if (end < start) {
                this.isError = true;
                this.errors.push(message);
            }
        }
        return this;
    }



    validateCompareData(expresion: boolean, message: string): MyCustomValidation {
        // Ensure _value is a string before checking its length
        if (expresion == false) {
            this.isError = true;
            this.errors.push(message);
        }
        return this;
    }

    validateInclude(lists: any[], message: string): MyCustomValidation {
        if (!lists?.includes(this._value)) {
            this.isError = true;
            this.errors.push(message);
        }
        return this;
    }

    validateIncludeByKey<T>(list: T[], key: keyof T, message: string): MyCustomValidation {
        if (!list.some(item => item[key] == this._value)) {
            this.isError = true;
            this.errors.push(message);
        }
        return this;
    }

    validateExpression(isOk: boolean, message: string): MyCustomValidation {
        // Allow numeric values including negative numbers and decimals
        if (isOk == false) {
            this.isError = true;
            this.errors.push(message);
        }
        return this;
    }

    validatePregMatch(preg: RegExp, message: string): MyCustomValidation {
        // 正規表現チェック
        const m = this._value.match(preg);

        if (m == null || m.length == 0) {
            this.isError = true;
            this.errors.push(message);
        }
        return this;
    }

    hasErrors(): boolean {
        return this.isError;
    }

    getErrors(): string[] {
        return this.errors;
    }
}
